<template>
  
  <main class="main">

    <the-nav-titles></the-nav-titles>

    <div class="container">

      <h1 class="title title_h1">{{ title }}</h1>

    </div>

    <div
      v-if="!loaded"
      class="loader"
    ></div>

    <template v-else>

      <div class="container">
        
        <div class="layout layout_default-page">
          
          <div class="layout__item">
            
            <h2 class="title title_h2">{{ lead.title }}</h2>

          </div>

          <div class="layout__item">
            
            <p class="lead lead_top" v-html="lead.desc"></p>

          </div>

        </div>

      </div>

      <div class="container container_collapse-right">

        <gallery-images
          ref="gallery"
          :images="images"
          class="gallery_career-page"
        ></gallery-images>

      </div>

      <div class="container">
        
        <div class="layout layout_default-page">
          
          <div class="layout__item">
            
            <h2 class="title title_h2">{{ positions.title }}</h2>

          </div>

          <div class="layout__item">

            <p
              v-html="positions.desc"
              class="lead lead_default"
            ></p>
            
            <div
              v-for="position in positions.items"
              class="position"
            >
              
              <div class="position__name">{{ position.name }}</div>

              <div
                v-html="position.desc"
                class="position__desc"
              ></div>

            </div>

          </div>

        </div>

        <div class="layout layout_default-page">
          
          <div class="layout__item">
            
            <h2 class="title title_h2">{{ apply.title }}</h2>

          </div>

          <div class="layout__item">
            
            <p
              v-html="apply.desc"
              class="lead lead_default"
            ></p>

            <form-container>

              <template slot-scope="props">
              
                <form-control name="first_name" label="Nome" :required="true"></form-control>

                <form-control name="last_name" label="Cognome" :required="true"></form-control>

                <form-control name="phone" type="tel" label="Telefono" :required="true"></form-control>

                <form-control name="email" type="email" label="Email" :required="true"></form-control>

                <form-control name="region" type="select" label="Regione" :options="optionsRegion" :required="true"></form-control>

                <form-control name="city" label="Città" :required="true"></form-control>

                <form-control name="vakancy" type="select" label="Posizione desiderata" :options="optionsVakancy"  :required="true"></form-control>

                <form-control name="file" type="file" :required="true">
                  
                  <template slot="before" slot-scope="props">

                    <label for="file" class="form-control__button">
                    
                      <span class="form-control__button-text">ALLEGA CV</span>
                    
                    </label>

                    <p
                      v-if="props.value !== null"
                      v-for="item in props.value"
                      class="form-control__file-name"
                    >{{ item.name }}</p>

                  </template>

                </form-control>

                <form-control name="checkbox" type="checkbox" :required="true">
                  
                  <template slot="after">
                  
                    <div class="form-control__wrapper">
                    
                      <label class="form-control__check-mark" for="checkbox"></label>
                    
                      <div class="form-control__caption">Dichiaro di aver preso visione dell'<a href="/privacy" class="career_privacy">informativa privacy</a> ed autorizzo 4MKTG For Marketing SRL al trattamento dei miei dati personali ai sensi del Regolamento UE 2016/679 per la gestione della candidatura.</div>
                    
                    </div>

                  </template>

                </form-control>

                <div class="form__footer">

                  <div class="form__submit">
                    
                    <button
                      class="button button_form-career-page"
                      type="submit"
                    >INVIA LA CANDIDATURA</button>

                  </div>

                  <div
                    v-show="props.verified === false"
                    class="form__hint"
                  >Per favore, inserisci le informazioni obbligatorie</div>

                </div>

              </template>

            </form-container>

          </div>

        </div>

      </div>

    </template>

  </main>

</template>

<script>
  import Utils from '@/mixins/Utils';

  import FormContainer from '@/components/FormContainer';
  import FormControl from '@/components/FormControl';
  import GalleryImages from '@/components/GalleryImages';
  import TheNavTitles from '@/components/TheNavTitles';
  import TouchHandler from '@/js/TouchHandler';
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    name: 'CareerPage',

    components: {
      FormContainer,
      FormControl,
      GalleryImages,
      TheNavTitles,
      VueRecaptcha,
    },

    mixins: [
      Utils,
    ],

    data() {
      return {
        apply: {
          title: null,
          desc: null,
        },
        images: [],
        lead: {
          title: null,
          desc: null,
        },
        loaded: false,
        positions: {
          title: null,
          desc: null,
          items: [],
        },
        optionsRegion: [
          {text: 'Abruzzo', value: 'Abruzzo'},
          {text: 'Basilicata', value: 'Basilicata'},
          {text: 'Calabria', value: 'Calabria'},
          {text: 'Campania', value: 'Campania'},
          {text: 'Emilia-Romagna', value: 'Emilia-Romagna'},
          {text: 'Friuli-Venezia Giulia', value: 'Friuli-Venezia Giulia'},
          {text: 'Lazio', value: 'Lazio'},
          {text: 'Liguria', value: 'Liguria'},
          {text: 'Lombardia', value: 'Lombardia'},
          {text: 'Marche', value: 'Marche'},
          {text: 'Molise', value: 'Molise'},
          {text: 'Piemonte', value: 'Piemonte'},
          {text: 'Puglia', value: 'Puglia'},
          {text: 'Sardegna', value: 'Sardegna'},
          {text: 'Sicilia', value: 'Sicilia'},
          {text: 'Toscana', value: 'Toscana'},
          {text: 'Trentino-Alto Adige', value: 'Trentino-Alto Adige'},
          {text: 'Umbria', value: 'Umbria'},
          {text: 'Valle d\'Aosta', value: 'Valle d\'Aosta'},
          {text: 'Veneto', value: 'Veneto'},
        ],
        optionsVakancy: [
          {text: 'Promoter/Hostess', value: 'Promoter/Hostess'},
          {text: 'Allestitore/Merchandiser', value: 'Allestitore/Merchandiser'},
          {text: 'Mystery client', value: 'Mystery client'},
          {
            text: 'Commerciale/In Store Account/Sales Merchandiser',
            value: 'Commerciale/In Store Account/Sales Merchandiser',
          },
          {text: 'Altro', value: 'Altro'},
        ],
        title: 'Career',
        touchArea: null,
        rcapt_sig_key: '6LelKDkUAAAAAMYCC2SBR4x6QpJHZPXneljYEOD0',
        rcapt_id: 0,
      };
    },

    created() {
      this.fetchData();
      // this.loadScript();
    },

    methods: {
      fetchData(res) {
        this.$http.get('/static/api/career.json')

        .then(this.onFulfilled);
      },

      onFulfilled(res) {
        const data = res.data;

        this.apply = data.apply;
        this.images = data.images;
        this.lead = data.lead;
        this.positions = data.positions;

        this.loaded = true;

        this.$nextTick(() => {
          this.touchArea = new TouchHandler(this.$refs.gallery.$el);
          this.touchArea.on('swipeX', this.onSwipeX);
        });
      },

      onSwipeX(direction) {
        if (direction === 'swipeleft') {
          this.$refs.gallery.prevImage();
        } else {
          this.$refs.gallery.nextImage();
        }
      },

    },
  };
</script>


// WEBPACK FOOTER //
// src/pages/career/Index.vue